import { memo, useRef } from "react";
import { extend, useFrame } from "@react-three/fiber";
import { Effects } from "@react-three/drei";
import { UnrealBloomPass, WaterPass } from "three-stdlib";
import { mapValue } from "../common/utils";
import { featuresContext as features } from "./features";

extend({ WaterPass, UnrealBloomPass });

const Post = ({ factor, sacred }) => {
  const ref = useRef();
  const { speed } = features;
  useFrame((state, delta) => {
    return (ref.current.time += delta * mapValue(speed, 10, 40, 1.5, 4));
  });
  return (
    <>
      <Effects>
        <unrealBloomPass strength={sacred ? 0.21 : 0.17} threshold={0.35} />
        <waterPass ref={ref} factor={factor} />
      </Effects>
    </>
  );
};

export default memo(Post);
